/**
 * Directive: paymentOptions
 */
angular.module('acme.common.directive.paymentOptions', ['acme.common.service.lunchLitely'])
.directive('paymentOptions', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/paymentOptions/paymentOptions.tpl.html',
      scope: {
        hideActions: '=',
        isUpdating: '=',
        model: '=',
        disabledOptions: '@',
        update: '&',
        create: '&'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        $scope.paymentOptions.init();
      },

      controller: ['$scope', 'LunchLitelyService', function($scope, lunchLitelyService) {

        $scope.paymentOptions = {

          isSaving: false,
          depositAmount: 0,
          depositDueDays: 0,
          balanceDueDays: 0,
          depositMinimumAmount: 0,
          depositMinimumPercent: 0,
          depositRequired: 'Yes',

          selectedDepositType: {},
          selectedPaymentType: {},
          uniqueVoucherNumbers: false,
          ticketDelivery: 'print',
          taxExempt: false,
          taxExemptEnabled: false,

          depositChoices: ['Yes', 'No'],

          depositTypes: [
            {
              name: 'percent',
              label: '% of total'
            },
            {
              name: 'minimum',
              label: 'Minimum'
            }
          ],
          paymentTypes: [
            {
              name: 'fullPayment',
              label: 'Pay in full'
            },
            {
              name: 'partialPayment',
              label: 'Partial payment'
            },
            {
              name: 'invoice',
              label: 'Invoice'
            },
            {
              name: 'deferredPayment',
              label: 'Deferred Payment'
            }
          ],

          init: function() {
            $scope.$watchCollection('model', this.onModelUpdate);
            $scope.$watch('isUpdating', this.onIsUpdating);
            $scope.$on('PaymentOptions::save', this.onSave);

            this.disableOptions();

            lunchLitelyService.isEnabled('tax_exempt_orgs').then(function(enabled) {
              $scope.paymentOptions.taxExemptEnabled = enabled;
            });

          },

          migrate: function(payment) {

            this.selectedPaymentType = this.findPaymentType(payment.type);
            this.uniqueVoucherNumbers = payment.uniqueVoucherNumbers;
            this.ticketDelivery = payment.ticketDelivery;
            this.taxExempt = payment.taxExempt;
            this.balanceDueDays = payment.balanceDueDays;
            this.depositDueDays = payment.depositDueDays;
            this.depositMinimumAmount = payment.depositMinimumAmount;
            this.depositMinimumPercent = payment.depositMinimumPercent;
            console.log('PaymentOptions::migrate', this.depositMinimumPercent, this.depositMinimumAmount);

            if (this.depositMinimumAmount && this.depositMinimumAmount > 0) {
              console.log('PaymentOptions::migrate', this.depositMinimumAmount, this.selectedDepositType);
              this.selectedDepositType = this.findDepositType('minimum');
              this.depositAmount = this.depositMinimumAmount;
            }else if (this.depositMinimumPercent && this.depositMinimumPercent > 0) {
              console.log('PaymentOptions::migrate', this.depositMinimumPercent + '%', this.selectedDepositType);
              this.selectedDepositType = this.findDepositType('percent');
              this.depositAmount = this.depositMinimumPercent;
            }else{
              this.selectedDepositType = this.findDepositType('percent');
            }

            if (this.depositDueDays || this.depositMinimumPercent || this.depositMinimumAmount) {
              this.depositRequired = 'Yes';
            }else{
              this.depositRequired = 'No';
            }

            console.log('PaymentOptions::migrate', this.depositRequired, this.selectedPaymentType, this.selectedDepositType);

          },

          process: function() {

            if (this.depositRequired === 'Yes') {
              if (this.selectedDepositType.name === 'percent') {
                this.depositMinimumPercent = this.depositAmount;
                this.depositMinimumAmount = 0;
              }else{
                this.depositMinimumAmount = this.depositAmount;
                this.depositMinimumPercent = 0;
              }
            }else{
              this.depositDueDays = 0;
              this.depositMinimumPercent = 0;
              this.depositMinimumAmount = 0;
            }

          },

          update: function() {

            var payment;

            this.process();

            payment = {
              accountId: $scope.model.accountId,
              type: this.selectedPaymentType.name,
              uniqueVoucherNumbers: this.uniqueVoucherNumbers,
              ticketDelivery: this.ticketDelivery,
              taxExempt: this.taxExempt,
              balanceDueDays: this.balanceDueDays,
              depositDueDays: this.depositDueDays,
              depositMinimumAmount: this.depositMinimumAmount,
              depositMinimumPercent: this.depositMinimumPercent
            };

            if ($scope.model.id) {
              payment.id = $scope.model.id;
              $scope.update({ payment: payment });
            }else{
              $scope.create({ payment: payment });
            }
          },

          isPaymentType: function(name) {
            return (this.selectedPaymentType.name === name);
          },

          findPaymentType: function(type) {
            var i, ii,
              r = false;

            for (i=0,ii=this.paymentTypes.length;i<ii;i++) {
              if (this.paymentTypes[i].name === type) {
                r = this.paymentTypes[i];
                break;
              }
            }

            return r;

          },

          disableOptions: function() {
            var o,
                i, ii,
                j, jj;

            if ($scope.disabledOptions) {
              if ($scope.disabledOptions.indexOf(',') >= 0) {
                o = $scope.disabledOptions.split(',');
              }else{
                o = [$scope.disabledOptions];
              }

              for (i=0,ii=o.length;i<ii;i++) {
                for (j=this.paymentTypes.length - 1,jj=0;j>jj;j--) {
                  if (this.paymentTypes[j].name === o[i]) {
                    this.paymentTypes.splice(j, 1);
                  }
                }

              }
            }

          },

          findDepositType: function(type) {
            var i, ii,
              r = false;

            for (i=0,ii=this.depositTypes.length;i<ii;i++) {
              if (this.depositTypes[i].name === type) {
                r = this.depositTypes[i];
                break;
              }
            }

            return r;
          },

          onModelUpdate: function(n, o) {
            $scope.paymentOptions.migrate(n);
          },
          onIsUpdating: function (n, o) {
            console.log('PaymentOptions::onIsUpdating', n);
            $scope.paymentOptions.isSaving = n;
          },
          onSave: function(e, data) {
            $scope.paymentOptions.update();
          }

        };

      }]

    };

}]);